import { MisterIcon } from "@rtel/mister-icons";
import { useTranslation } from "react-i18next";

const TableActionButtons = ({event, canDelete, canEdit, showDetails}: IReportDownload) => {
  const canPerformAction = canEdit || canDelete || showDetails;
  const { t } = useTranslation();

  return (
    <>
      {canPerformAction && (
        <>
          {canDelete &&
            <div
              className="text-danger ms-2 me-2 order-3"
              style={{ cursor: "pointer" }}
              onClick={() => { event({action: "delete"}) }}
            >
              <MisterIcon name="Delete" size="sm" className="icon-danger me-1"/>
              { t("Delete") }
            </div>
          }

          {canEdit &&
            <div
              className="text-primary ms-2 order-3"
              style={{ cursor: "pointer" }}
              onClick={() => { event({action: "edit"}) }}
            >
              <MisterIcon name="Edit" size="sm" className="icon-info me-1"/>
              { t("Edit") }
            </div>
          }

          {showDetails &&
            <span
              className="d-inline-block text-primary"
              style={{ cursor: "pointer" }}
              onClick={() => { event({action: "showDetails"}) }}
            >
              <MisterIcon name="Doc2" size="sm" className="icon-info me-1"/>
              { t("Λεπτομέρειες") }
            </span>
          }

        </>
      )}
    </>
  )
}

export default TableActionButtons;

interface IReportDownload {
  event: (value: IEvent) => void;
  canEdit: boolean;
  canDelete: boolean;
  showDetails?: boolean
} 